<template>
	<div>
		<Modal 
		:loading="loading" 
		:title="((this.current == 'new') ? 'NOVO CENTRO DE DISTRIBUIÇÃO' : 'EDITAR CENTRO DE DISTRIBUIÇÃO')"
		@close="close"
		@save="save">
			<div class="row">
				<div :class="client_atak ? 'col-xs-8' : 'col-xs-12'">
					<FormInput v-model="name" label="Nome" type="text" :required="true" tooltip="Informe o nome do centro" ref="name" />
				</div>
                <div v-if="client_atak" class="col-xs-4">
					<FormInput v-model="code" label="Código do estoque" type="text" :required="false" tooltip="Informe o código do estoque ('chave fato' do registro do estoque no sistema integrado)" ref="code" />
				</div>
            </div>
            <form-group-address
                :current_id="id"
                :current_postal_code="postal_code"
                :current_street="street"
                :current_number="number"
                :current_complement="complement"
                :current_neighborhood="neighborhood"
                :current_city="city"
                :current_uf="uf"
                :current_country="country"
                :current_coordinates="coordinates"
                ref="formGroup"
            >
            </form-group-address>
            <div class="row" style="padding-bottom: 25px;">
				<div class="col-xs-12">
					<FormCheckbox v-if="false" v-model="is_dc" label="É um Centro de Distribuição?" icon="fa-pallet" tooltip="Informe se é um centro ou somente um local de estoque" ref="is_dc" />
				</div>
				<div class="col-xs-12">
					<FormTextarea v-model="observation" label="Observação" tooltip="Informe uma observação adicional que desejar" ref="observation" />
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormCheckbox from "@/components/FormCheckbox";
import FormInput from "@/components/FormInput";
import FormTextarea from "@/components/FormTextarea";
import FormGroupAddress from '@/components/FormGroupAddress.vue';

export default {
	name: "DistributionCenterForm",

	props: ["current"],

	components: {
        Modal,
        FormCheckbox,
        FormInput,
        FormTextarea,
        FormGroupAddress,
    },

	data: function() {
        if(this.current != 'new') {
			return {
                loading: false,
                
                id: this.current.id,
                is_dc: 1,
				code: this.current.code ? this.current.code : "",
				name: this.current.name,
				postal_code: this.current.postal_code,
                street: this.current.street,
                number: this.current.number,
                complement: this.current.complement,
                neighborhood: this.current.neighborhood,
                city: this.current.city,
                uf: this.current.uf,
                country: "BRASIL",
                coordinates: {
                    lat: this.current.coordinates.split(",")[0],
                    lng: this.current.coordinates.split(",")[1],
                },
                observation: this.current.observation,
                client_atak: this.$api.user.company_client_atak,
			}
        }
        
		return {
            loading: false,
            
            id: '',
            is_dc: 1,
            code: '',
            name: '',
            postal_code: '',
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            uf: '',
            country: 'BRASIL',
            coordinates: null,
            observation: '',
            client_atak: this.$api.user.company_client_atak,
		}
	},

	methods: {
        // Verifica e valida inicialmente os campos
		validation: function() {
            let data = {};

            let dataDC = {
                id: '',
                code: '',
                name: '',
                observation: '',
            };
            let error = false;
            
            // Id 
            dataDC.id = this.id;

            dataDC.code = this.code;

			// Nome
			if (this.name == "") {
                this.$refs.name.validate();
				this.$notification.error(this.message("NOME"));
                error = true;
			} else {
				dataDC.name = this.name;
			}
            
            // Observação
            dataDC.observation = this.observation;
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                let dataAddress = this.$refs.formGroup.validation();
                if (dataAddress) {
                    data = Object.assign({}, dataDC, dataAddress);
                    return data;
                } else {
                    return null;
                }
            }
        },

		// Envia para API e salva as informações no BD
        save: async function() {
            if (this.id) {
				let confirm = await this.$alert.confirm("Deseja mesmo EDITAR esse centro de distribuição?");
				if (!confirm) return;
			}

            // Solicita a validação
			let form = this.validation();

            // Verifica o resultado da validação
			if(form == null) {
				return;
            }
            
            // Requisita o salvamento
			this.loading = true;
            let result = null;

            // Verifica se é edição
            try {
                if(this.id != "") {
                    result = await Api.post("distribution-center/edit", form);
                } else {
                    result = await Api.post("distribution-center/save", form);
                }
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível salvar as informações.");
                return;
            }

			this.loading = false;
            
            // Verifica o resultado da requisição
			if(result.error == true) {
                // Se tiver erro exibe as mensagens
				for(let i = 0; i < result.data.length; i++) {
					this.$notification.error(result.data[i]);
				}
			} else {
                // Senão houver exibe o sucesso
                // Verifica se é edição
                if(this.id != "") {
                    this.$notification.success("Alterado com sucesso.");
                } else {
                    this.$notification.success("Adicionado com sucesso.");
                }
                // Fecha o modal e recarrega a lista
				this.close();
				this.$parent.load();
			}
            return;
		},

        // Fecha o modal
		close: function() {
			this.$parent.current = false;
        },
	}
}
</script>

<style scoped>
.google-maps-label {
    font-size: 12px;
    color: #666;
}

.google-maps-form {
	width: 100%;
	position: relative;
	height: 350px;
    border: 1px solid #aaa;
    margin-bottom: 35px;
}
</style>